import * as Yup from 'yup';

export const packageScheme = Yup.object().shape({
  title: Yup.string().required('Required Field'),
  description: Yup.string(),
  has_custom_donation_amount: Yup.boolean()
});
